import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class StateService {



  constructor() { }

  private _pageSize = 25; // Default page size

  get pageSize(): number {
    return this._pageSize;
  }

  set pageSize(value: number) {
    this._pageSize = value;
  }
}
